import { getResource } from './BaseRequests'


//fetch list of products in specific category
export const fetchListing = ({ listingId }, success, fail) => {
    const listingIdStr = String(listingId)
	//console.log("listingIdStr: " + listingIdStr);
    getResource("products", {id: listingIdStr}).then(success).catch(fail)
}

// export const  fetchProductsAndBrands = ({listingId}) =>{
//     const listingIdStr = String(listingId)
//     return getResource("category_brands", {id:listingIdStr})
// }

export const fetchBrandsInListing = ( {listingId}) => {
    const listingIdStr = String(listingId)
    return getResource("category_brands", {id: listingIdStr}).then(brandsList => {
        //sort the objects at this point
        return Object.values(brandsList || {}).sort((a, b) => a.title.localeCompare(b.title))
    })
}

// fetch the specials given a category ID
export const fetchSpecials = ({ categoryId }, success, fail) => {
    const listingIdStr = String(categoryId)
    getResource("category_specials", { id: listingIdStr }).then(specials =>{
        //sort before returning specials
        let arr = Object.values(specials || {})
        arr.sort((a, b) => a.title.localeCompare(b.title)) //sort into alphabetical order
        return success(arr)
    }).catch(fail)
}

export const fetchMemberBiz = ({listingId}, success, fail) =>{
    const listingIdStr = String(listingId)
    getResource("member_biz", {id: listingIdStr}).then(success).catch(fail)
    // getResource("member_biz").then(success).catch(fail)
}

export const fetchDiscountPartners = ({listingId},success, fail) => {
    const listingIdStr = String(listingId)
    getResource("discount_partners", { id: listingIdStr }).then(success).catch(fail)
}

export const fetchDiscountPartner = (productId, success, fail) => {
    const productIdStr = String(productId)
    getResource("discount_partner", { id: productIdStr }).then(success).catch(fail)
}

export const fetchAllSpecials = (success, fail) => {
  getResource("all_specials").then(success).catch(fail);
}
